import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'
import { Pagination, Tooltip } from 'antd';
import { useTheme } from "./theme-provider.js"
import Select from 'react-select';

import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js"
import PageError from '../common_component/PageError.js';
import formatNumber from '../common_component/formatNumber.js';
import { ReportWidgetWrapper, ReportWidgetItem } from '../common_component/ReportWidgets.js';

function DayBookReport() {

    const [state, setstate] = useState(2);
    const { theme, dropdownStyleDark } = useTheme()

    const [baseCurrency, setBaseCurrency] = useState(null)

    const [dayBookReportList, setDayBookReportList] = useState([])
    const [dayBookReportApiState, setDayBookReportApiState] = useState(false)

    const daterange_picker_ref = useRef()
    const apiController = useRef(new AbortController())

    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [startDate, setStartDate] = useState(moment.utc().format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"))

    const [calculationMode, setCalculationMode] = useState({ label: "Accrual", value: "Accrual" })
    const [includePendingDocuments, setIncludePendingDocuments] = useState({ label: "Include Paid Entries only", value: "Include Paid Entries only" })

    var page_name = "day-book-report";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };

    let formatNumberOptions = {
        removeTrailingZeros: true
    }

    async function getDayBookReport(cp, rpp, sd, ed, cm, ipd) {
        try {
            if (dayBookReportApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setDayBookReportApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-day-book-report`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "current_page": cp - 1, "rows_per_page": rpp, "start_date": sd, "end_date": ed, "calculation_mode": cm, "include_pending_documents": ipd, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();

            if (body.operation !== "success") throw "get Day Book Report api error"

            setDayBookReportList(body.data.list)
            setListCount(body.data.count)

            setDayBookReportApiState(false)
        } catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function getBaseCurrency() {
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/get-base-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();

        // console.log(body)
        if (body.length > 0) {
            setBaseCurrency(body[0])
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            let p1 = getDayBookReport(currentPage, rowsPerPage, startDate, endDate, calculationMode.value, includePendingDocuments.value)
            let p2 = getBaseCurrency()

            Promise.all([p1, p2])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    useEffect(() => {
        if (state === 1) {
            getDayBookReport(currentPage, rowsPerPage, startDate, endDate, calculationMode.value, includePendingDocuments.value)
        }
    }, [currentPage, rowsPerPage, startDate, endDate, calculationMode, includePendingDocuments])

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Day Book Report</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Tooltip title="SpotERP Docs" >
                        <a
                            href={`${process.env.REACT_APP_SPOTERP_DOCS}/reports/accounting/day_book_report`}
                            className='btn btn-light-primary py-2 px-3'
                            target="_blank"
                        >
                            <i className="bi bi-journal-text fs-1 px-0"></i>
                        </a>
                    </Tooltip>
                        <DateRangePickerComponent
                            ref={daterange_picker_ref}
                            allowEdit={false}
                            showClearButton={false}
                            focus={() => { daterange_picker_ref.current.show() }}
                            delayUpdate={true}
                            presets={[
                                { label: 'Today', start: new Date(), end: new Date() },
                                { label: 'Last 7 days', start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date() },
                                { label: 'Last 30 days', start: new Date(new Date().setDate(new Date().getDate() - 30)), end: new Date() },
                                { label: 'Last 90 days', start: new Date(new Date().setDate(new Date().getDate() - 90)), end: new Date() }
                            ]}
                            change={(e) => {
                                setStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                setEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                            }}
                            startDate={new Date(startDate)}
                            endDate={new Date(endDate)}
                            max={new Date().toISOString().split('T')[0]}
                        />
                    </div>
                </div>
                <div>
                    {
                        state === 1 ?
                            <div className="card mb-5 mb-xl-8">
                                <div className="card-header border-0">
                                    <ReportWidgetWrapper>
                                        <ReportWidgetItem
                                            icon={<i className="bi bi-clipboard-data-fill display-6 me-2" style={{ color: "rgb(97 97 230 / 75%)" }}></i>}
                                            label={"Total Debit"}
                                            value={baseCurrency.currency_symbol + formatNumber(dayBookReportList.reduce((p, o) => p + (o.transaction_type === "DEBIT" ? o.amount : 0), 0), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place, shorten: true, shortenFormat: '1K, 1L, 1Cr' })}
                                            hoverValue={baseCurrency.currency_symbol + formatNumber(dayBookReportList.reduce((p, o) => p + (o.transaction_type === "DEBIT" ? o.amount : 0), 0), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}
                                        />
                                        <ReportWidgetItem
                                            icon={<i className="bi bi-shop-window display-6 me-2" style={{ color: "rgb(97 97 230 / 75%)" }}></i>}
                                            label={"Total Credit"}
                                            value={baseCurrency.currency_symbol + formatNumber(dayBookReportList.reduce((p, o) => p + (o.transaction_type === "CREDIT" ? o.amount : 0), 0), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place, shorten: true, shortenFormat: '1K, 1L, 1Cr' })}
                                            hoverValue={baseCurrency.currency_symbol + formatNumber(dayBookReportList.reduce((p, o) => p + (o.transaction_type === "CREDIT" ? o.amount : 0), 0), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}
                                        />
                                    </ReportWidgetWrapper>
                                </div>

                                <div className="card-body py-3">
                                    <div className='row'>
                                        <div className='col-md-6 mb-5'>
                                            <Select
                                                options={["Accrual", "Cash"].map(x => { return { label: x, value: x } })}
                                                onChange={(val) => { setCalculationMode(val); setIncludePendingDocuments({ label: "Include Paid Entries only", value: "Include Paid Entries only" }); }}
                                                value={calculationMode}
                                                placeholder="Select Type..."
                                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                            />
                                        </div>
                                        <div className='col-md-6 mb-5'>
                                            <Select
                                                options={["Include Pending Approval Entries", "Include Paid Entries only"].map(x => { return { label: x, value: x } })}
                                                onChange={(val) => { setIncludePendingDocuments(val) }}
                                                value={includePendingDocuments}
                                                isDisabled={calculationMode.value != "Accrual"}
                                                placeholder="Select Type..."
                                                styles={theme == 'dark' ? dropdownStyleDark : {}}
                                            />
                                        </div>
                                    </div>

                                    <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                        {
                                            dayBookReportApiState ?
                                                <div className="spinner-border text-primary w-75px h-75px my-auto"></div>
                                                :
                                                dayBookReportList.length > 0 ?
                                                    <>
                                                        <div className="mb-5 d-flex justify-content-center">
                                                            <Pagination
                                                                total={listCount}
                                                                onChange={(page, pageSize) => {
                                                                    setCurrentPage(page);
                                                                    setRowsPerPage(pageSize);
                                                                }}
                                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                pageSize={rowsPerPage}
                                                                current={currentPage}
                                                                showSizeChanger={true}
                                                                showQuickJumper={true}
                                                            />
                                                        </div>

                                                        <div className='overflow-auto w-100 flex-grow-1'>
                                                            <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3" style={{ minWidth: "1000px" }}>
                                                                <thead>
                                                                    <tr className="fw-bold text-muted">
                                                                        <th className="min-w-120px">Date</th>
                                                                        <th className="min-w-120px">Transaction Details</th>
                                                                        <th className="min-w-120px">Transaction Type</th>
                                                                        <th className="min-w-120px">Debit</th>
                                                                        <th className="min-w-120px">Credit</th>
                                                                        <th className="min-w-120px">Transaction No.</th>
                                                                        <th className="min-w-120px">Reference</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        dayBookReportList.map((obj, indx3) => {
                                                                            return (
                                                                                <tr key={obj._id}>
                                                                                    <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{calculationMode.value === "Accrual" ? moment(obj.date_time).format("ll") : moment(obj.date_time).format("lll")}</span></td>
                                                                                    <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">
                                                                                        <span>{obj.user_name}</span><br />
                                                                                        <span className='badge badge-primary text-uppercase'>{obj.user_type}</span>
                                                                                    </span></td>
                                                                                    <td><span className={`fw-bold text-hover-primary d-block mb-1 fs-6 text-uppercase ${obj.transaction_type === "DEBIT" ? "text-danger" : "text-success"}`}>{obj.transaction_type}</span></td>
                                                                                    <td><span className={`fw-bold text-hover-primary d-block mb-1 fs-6 ${obj.transaction_type === "DEBIT" ? "text-danger" : "text-gray-400"}`}>{baseCurrency.currency_symbol}&nbsp;{formatNumber((obj.transaction_type === "DEBIT" ? obj.amount : 0), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}</span></td>
                                                                                    <td><span className={`fw-bold text-hover-primary d-block mb-1 fs-6 ${obj.transaction_type === "CREDIT" ? "text-success" : "text-gray-400"}`}>{baseCurrency.currency_symbol}&nbsp;{formatNumber((obj.transaction_type === "CREDIT" ? obj.amount : 0), { ...formatNumberOptions, currencyFormat: baseCurrency.format, decimalPlaces: baseCurrency.decimal_place })}</span></td>
                                                                                    <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">
                                                                                        <span>{obj.transaction_number}</span>
                                                                                        {calculationMode.value === "Accrual" && obj.is_pending && <><br /><span className='badge badge-warning'>Pending Approval</span></>}
                                                                                    </span></td>
                                                                                    <td><span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.reference}</span></td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        <div className="mt-5 d-flex justify-content-center">
                                                            <Pagination
                                                                total={listCount}
                                                                onChange={(page, pageSize) => {
                                                                    setCurrentPage(page);
                                                                    setRowsPerPage(pageSize);
                                                                }}
                                                                showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                                                                pageSize={rowsPerPage}
                                                                current={currentPage}
                                                                showSizeChanger={true}
                                                                showQuickJumper={true}
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="text-muted fs-2 my-auto text-center">No data to be shown {/* <br /> <br />
                                                            <button className='btn fs-3 btn-light-primary' onClick={() => { setFlowModalShow(true) }}>
                                                                Need Help <i className="bi bi-question-circle fs-1"></i>
                                                            </button> */}
                                                    </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            :
                            state === 2 ?
                                <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                :
                                <PageError />
                    }
                </div>
            </div>
        </>
    );
}

export default DayBookReport;